//client/src/hooks/useDivesitesContext.js

import { DivesitesContext } from "../contexts/divesiteContext.js";
import { useContext } from "react";

export const useDivesitesContext = () => {
    const context = useContext(DivesitesContext);
    
    if (context === undefined) {
        throw Error('useDivesitesContext must be used within a DivesitesContextProvider');
    }
    
    return context;
}